import React, { useEffect, useState } from "react";
import "./PGAModelBuilderInputConfig.css";
import PGAModelBuilderInput from "../PGAModelBuilderInput";
import PGAModelBuilderButton from "../PGAModelBuilderButton";
import Select from "react-select";
import FlexBreak from "../../../../../FlexBreak";
import SelectField from "../../../../../SelectField";
import MultiSelectFilter from "../../../__nfl/NFLStatEnginePage/NFLStatEngine/StatFilters/MultiSelectFilter";
import CustomMultiSelect from "../../../../../CustomMultiSelect";
import { useLazyLoadQuery, graphql, commitMutation } from "react-relay";
import relayEnvironment from "../../../../../../RelayEnvironment";

const GRASS_QUERY = graphql`
  query PGAModelBuilderInputConfigGrassCategoryQuery {
    grassCategories {
      id
      categoryName
    }

    pgaTourCourses {
      id
      name
    }
  }
`;

const BUILD_MODEL = graphql`
  mutation PGAModelBuilderInputConfigBuildModelMutation(
    $input: PGATourBuildModelInput!
  ) {
    pgaTourBuildModel(input: $input) {
      success
    }
  }
`;

export default function PGAModelBuilderInputConfig(props) {
  const [modelBuilding, setModelBuilding] = useState(false);
  const data = useLazyLoadQuery(GRASS_QUERY);

  const grassOptions = data.grassCategories.map((cat) => {
    return {
      value: cat.id,
      label: cat.categoryName,
    };
  });

  const courseOptions = data.pgaTourCourses.map((course) => {
    return {
      value: course.id,
      label: course.name,
    };
  });

  function buildModel() {
    setModelBuilding(true);

    commitMutation(relayEnvironment, {
      mutation: BUILD_MODEL,
      variables: {
        input: {
          modelId: props.modelId,
        },
      },
      onCompleted: (resp) => {
        const success = resp.pgaTourBuildModel.success;

        if (success) {
          props.buildSucceeded();
        }

        setModelBuilding(false);
      },
    });
  }

  useEffect(() => {
    if (props.filterLoads > 0) {
      buildModel();
    }
  }, [props.filterLoads]);

  function updateGrassTypes(area, selectedGrassTypes) {
    if (!props.modelId) return;
  }

  function updateSelectedCoursePars(selected) {
    const newArr = [...props.coursePars];

    if (props.coursePars.includes(selected)) {
      newArr.splice(newArr.indexOf(selected), 1);
    } else {
      newArr.push(selected);
    }
    props.setAndUpdateCoursePars(newArr);
  }

  return (
    <div className="pga-model-builder-input-config-container">
      <div className="pga-model-builder-input-config-column">
        <div style={{ width: "100%", flex: "1 1 0", zIndex: "5" }}>
          <label>
            Fairway Grass Type{" "}
            <CustomMultiSelect
              options={grassOptions}
              defaultValue={props.selectedFairwayGrassTypes}
              values={props.selectedFairwayGrassTypes}
              itemName={"grass"}
              onChange={(selected) => {
                props.setAndUpdateSelectedFairwayGrassTypes(selected);
                updateGrassTypes("FAIRWAY", selected);
              }}
            />
          </label>
        </div>
        <FlexBreak />
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label style={{ flex: "1 1 0" }}>
          Num Rounds{" "}
          <PGAModelBuilderInput
            type="number"
            value={props.numRounds}
            onChange={(e) => props.setAndUpdateNumRounds(e.target.value)}
          />
        </label>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label style={{ flex: "1 1 0" }}>
          Min Rounds{" "}
          <PGAModelBuilderInput
            type="number"
            value={props.minRounds}
            onChange={(e) => props.setAndUpdateMinRounds(e.target.value)}
          />
        </label>
        <FlexBreak />
        <div style={{ width: "100%", flex: "1 1 0", zIndex: "4" }}>
          <label>
            Course Filter {/*<Select*/}
            {/*  id="slate-select"*/}
            {/*  options={courseOptions}*/}
            {/*  isMulti*/}
            {/*  onChange={() => {}}*/}
            {/*  defaultValue={courseOptions}*/}
            {/*/>*/}
            <CustomMultiSelect
              options={courseOptions}
              defaultValue={props.selectedCourses}
              itemName={"course"}
              onChange={(values) => props.setAndUpdateSelectedCourses(values)}
              values={props.selectedCourses}
            />
          </label>
        </div>
      </div>
      <div className="pga-model-builder-input-config-column">
        <div style={{ width: "100%", flex: "1 1 0", zIndex: "5" }}>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>
            Green Grass Type
            <CustomMultiSelect
              options={grassOptions}
              defaultValue={props.selectedGreenGrassTypes}
              values={props.selectedGreenGrassTypes}
              itemName={"grass"}
              onChange={(selected) => {
                props.setAndUpdateSelectedGreenGrassTypes(selected);
                updateGrassTypes("GREEN", selected);
              }}
            />
          </label>
        </div>
        <FlexBreak />
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label style={{ flex: "1 1 0" }}>
          From Date{" "}
          <PGAModelBuilderInput
            type="date"
            value={props.fromDate}
            onChange={(e) => props.setAndUpdateFromDate(e.target.value)}
          />
        </label>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label style={{ flex: "1 1 0" }}>
          To Date{" "}
          <PGAModelBuilderInput
            type="date"
            value={props.toDate}
            onChange={(e) => props.setAndUpdateToDate(e.target.value)}
          />
        </label>
        <FlexBreak />
        <div style={{ width: "100%", flex: "1 1 0" }}>
          <label>
            Course Par{" "}
            <div style={{ height: "38px" }}>
              <SelectField
                options={[70, 71, 72, 73]}
                selected={props.coursePars}
                setSelected={updateSelectedCoursePars}
                isMulti={true}
              />
            </div>
          </label>
        </div>
      </div>
      <div className="pga-model-builder-input-config-column">
        <div style={{ width: "100%", flex: "1 1 0", zIndex: "5" }}>
          <label>
            Rough Grass Type{" "}
            <CustomMultiSelect
              options={grassOptions}
              defaultValue={props.selectedRoughGrassTypes}
              values={props.selectedRoughGrassTypes}
              itemName={"grass"}
              onChange={(selected) => {
                props.setAndUpdateSelectedRoughGrassTypes(selected);
                updateGrassTypes("ROUGH", selected);
              }}
            />
          </label>
        </div>
        <FlexBreak />
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label style={{ flex: "1 1 0" }}>
          Min Yards{" "}
          <PGAModelBuilderInput
            type="number"
            value={props.minYards}
            onChange={(e) => props.setAndUpdateMinYards(e.target.value)}
          />
        </label>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label style={{ flex: "1 1 0" }}>
          Max Yards{" "}
          <PGAModelBuilderInput
            type="number"
            value={props.maxYards}
            onChange={(e) => props.setAndUpdateMaxYards(e.target.value)}
          />
        </label>
        <FlexBreak />
        {/* Flex shenanigans create an empty label line to align with others columns */}
        <div
          className="pga-model-builder-input-config-submit"
          style={{
            height: "calc(38px + 18px)",
            display: "flex",
            alignItems: "end",
          }}
        >
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label style={{ width: "100%" }}>
            <PGAModelBuilderButton
              style={{ backgroundColor: "#ff5964", color: "white" }}
              onClick={buildModel}
              modelBuilding={modelBuilding}
            >
              Build Model
            </PGAModelBuilderButton>
          </label>
        </div>
      </div>
    </div>
  );
}
